export const getBackgroundColor = (snapshot) => {
    // Giving isDraggingOver preference
    if (snapshot.isDraggingOver) {
        return 'rgba(240,240,245,0.3)';
    }
    // If it is the home list but not dragging over
    if (snapshot.draggingFromThisWith) {
        return 'white';
    }
    // Otherwise use our default background
    return 'white';
};
